import { render } from "./LottoEtcView.vue?vue&type=template&id=3eb3c3f0&ts=true"
import script from "./LottoEtcView.vue?vue&type=script&lang=ts"
export * from "./LottoEtcView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__